import ImportContactsRoundedIcon from '@mui/icons-material/ImportContactsRounded';
import Person from '@mui/icons-material/Person';
import { webPortalApi } from '#config/web-portal-api';
import { DefaultOption } from '#service/autocomplete-service/option';
import { getRequestOptions } from '#helper';

class RecipientShipmentOptionService {
  #searchFields;

  constructor(searchFields) {
    if (!searchFields?.length) {
      throw new Error('Search fields are not provided');
    }

    this.#searchFields = searchFields;
  }

  async fetchOptionsRaw(value, fetchOptions = {}) {
    const searchParams = new URLSearchParams({
      offset: 0,
      filterBy: this.#searchFields,
      filter: value
    });

    const contactsUrl = webPortalApi.buildApiUrl(`shipment/notification/contact?${searchParams.toString()}`);
    const res = await fetch(contactsUrl, { ...getRequestOptions(), ...fetchOptions });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const options = await res.json();
    return options;
  }

  async getOptions(value, fetchOptions) {
    if (!value) {
      return [];
    }

    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options.map(option => {
      const label = `${option.firstName} ${option.lastName}`;
      const icon = option.type === 'user' ? Person : ImportContactsRoundedIcon;
      return new DefaultOption(option, icon, label);
    });
  }
}
export default RecipientShipmentOptionService;
